import { render, staticRenderFns } from "./TransferDetails.vue?vue&type=template&id=7b02e5d0&scoped=true&"
import script from "./TransferDetails.vue?vue&type=script&lang=js&"
export * from "./TransferDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransferDetails.vue?vue&type=style&index=0&id=7b02e5d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b02e5d0",
  null
  
)

export default component.exports